"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decimalToHexString = void 0;
exports.decimalToHexString = function (decimal) {
    var hex = Math.round(decimal).toString(16);
    if (hex === '0') {
        return '00';
    }
    return hex;
};
